import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import PostsList from '../components/PostsList'
import SEO from '../components/SEO'
import styled from 'styled-components'
import TopicItem from '../components/TopicItem'
import '@fontsource/rubik/800.css'
import '@fontsource/roboto/400.css'
import Button from '../components/Button'
import Bio from '../components/Bio'
import kebabCase from "lodash/kebabCase"
import {HiArrowRight} from 'react-icons/hi'
import startCase from 'lodash/startCase'

const HomeHero = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: var(--color-primaryBackground);
    top: 0;
    display: flex;
    align-items: center;
    text-align: center;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    
    
`

const HomeHeroInfo = styled.div`
    display: block;
    margin-left: 8%;
    width: 70%;
    color: var(--color-secondaryText);
    align-items: left;
    text-align: left;
    @media screen and (max-width: 900px) {
      width: 70%;
    }


`
const HomeHeroInfoHeading = styled.h1`
    text-decoration: none;
    font-family: 'Rubik';
    padding-bottom: 20px;
    align-items: center;
    font-size: 4.3rem;
    text-transform: uppercase;
    font-weight: 1700;
    line-height: 2cm;
    @media screen and (max-width: 900px) {
      line-height: 1.5cm;
      font-size: 3.5rem;
    }
    @media screen and (max-width: 768px) {
      line-height: 1.3cm;
      font-size: 2.3rem;
    }

    @media screen and (max-width: 420px) {
      line-height: 1.2cm;
      font-size: 2.2rem;
    }
    
`
const HomeHeroInfoHeadingSpan = styled.span`
  padding-right: 15px;
  padding-left: 0;
  padding-top: 5px;
  padding-bottom: 5px;
  background: linear-gradient(120deg, #004a8f 0%, #28d79a 100%);
  -webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
  @media screen and (max-width: 900px) {
      padding: 5px;
      margin-left: -5px;
    }
`
const HomeBodyWrapper = styled.div`
  background-color: var(--color-darkerBackground);
  width: 96%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border: 15px solid var(--color-primaryBackground);
  border-radius: 50px;
  transform: translateY(-55px);
  padding: 10px;
  z-index: 10;
  

`

const RecentPostsSection = styled.div`
    position: relative;
    display: table;
    width: 100%;
    border-radius: 45px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding-top: 25px;
    padding-bottom: 25px;
    @media screen and (max-width: 768px) {
      & {
        padding-top: 20px;
        padding-bottom: 20px;
      }
    }
    @media screen and (max-width: 768px) {
      & {
        padding-top: 15px;
        padding-bottom: 15px;
      }
    }


`

const SectionTitle = styled.h1`
    margin-left: 3%;
    text-decoration: none;
    font-size: 3.3rem;
    padding-top: 20px;
    padding-bottom: 10px;
    font-weight: 1500;
    line-height: 1.3cm;
    color: var(--color-secondaryText);
    border-bottom: 2px solid;
    border-image: linear-gradient(120deg, #004a8f 0%, #28d79a 100%);
    border-image-slice: 1;
    font-family: 'Rubik';
    @media screen and (max-width: 768px) {
      & {
        font-size: 2.9rem;
      }
    }
    @media screen and (max-width: 420px) {
      & {
        font-size: 2.5rem;
        margin-left: 2%;

      }
    }

`

const AllBtn = styled.div`
    position: absolute;
    right: 15px;
    transform: translateY(-55px);
    font-family: 'Roboto';
`
const RecentPosts = styled.div`
  padding-top: 40px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 20px;
  @media screen and (max-width: 900px) {
    & {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  @media screen and (max-width: 420px) {
    & {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
`
const TopicsSection = styled.div`
  position: relative;
  display: table;
  width: 100%;
  border-radius: 45px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding-top: 25px;
  padding-bottom: 30px;
  z-index: 5;
`

const Topics = styled.div`
  padding-top: 70px;
  padding-left: 45px;
  padding-right: 45px;
  padding-bottom: 40px;
  list-style: none;
  display: grid;
  justify-items: center;
  grid-gap: 60px;
  grid-template-columns: repeat(3, 1fr);
  font-family: 'Rubik';
  li {
    padding: 0;
    
  }
  @media screen and (max-width: 900px) {
    & {
      grid-template-columns: repeat(2, 1fr);
      padding-left: 40px;
      padding-right: 40px;
    }
  }
  @media screen and (max-width: 768px) {
    & {
      grid-template-columns: repeat(2, 1fr);
      padding-left: 30px;
      padding-right: 30px;
    }
  }
  @media screen and (max-width: 420px) {
    & {
      grid-template-columns: repeat(1, 1fr);
      padding-left: 20px;
      padding-right: 20px;
    }
  }

`

const AuthorSection = styled.div`
  position: relative;
  display: table;
  width: 100%;
  border-radius: 45px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding-top: 25px;
  padding-bottom: 25px;
  z-index: 5;
`

const AuthorInfo = styled.div`
  text-decoration: none;
  padding: 10px;
  margin-left: 60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: left;
  width: 90%;
  margin-top: 10px;
  @media screen and (max-width: 900px) {
    & {
      padding: 6px;
      width: 99%;
      margin-left: 0;
      felx-direction: row;
    }
  }
  @media screen and (max-width: 768px) {
    & {
      padding: 6px;
      width: 99%;
      margin-left: 0;
      felx-direction: row;
      text-align: left;

    }
  }
  @media screen and (max-width: 420) {
    & {
      padding: 6px;
      width: 95%;
      margin-left: 0;
      felx-direction: row;
      text-align: center;
    }
  }


`



class BlogList extends React.Component {
  
  render() {
    const posts = this.props.data.posts.edges
    const group = this.props.data.topics.group
    return (
      <Layout>
        <SEO />
        <HomeHero>
          <HomeHeroInfo>
            <HomeHeroInfoHeading>
              Ready to <HomeHeroInfoHeadingSpan>electrify </HomeHeroInfoHeadingSpan> your programming or web development journey?
            </HomeHeroInfoHeading>
            {/* <HomeHeroInfoPara>
              Programming and Web Development tutorials.
            </HomeHeroInfoPara> */}
              <Button type={'big-primary'} to='/articles'>Get Started</Button>
          </HomeHeroInfo>
        </HomeHero>
        <HomeBodyWrapper>
          <RecentPostsSection>
            <SectionTitle>
              Recent Articles
              <AllBtn><Button type="mini-primary" textColor='var(--color-secondaryText)' to="/articles">All Posts <HiArrowRight /> </Button></AllBtn>
            </SectionTitle>
            <RecentPosts>
              <PostsList posts={posts} />
            </RecentPosts>
          </RecentPostsSection>
          <TopicsSection>
            <SectionTitle>
              Popular Topics
              <AllBtn><Button type="mini-primary" textColor='var(--color-secondaryText)' to="/topics">All Topics <HiArrowRight /> </Button></AllBtn>
            </SectionTitle>
            
            <Topics>
              {group.map(topic => (
                <li key={kebabCase(topic.fieldValue)}>
                    <TopicItem type={kebabCase(topic.fieldValue)} size='20px' fontSize='26px' to={`/topics/${kebabCase(topic.fieldValue)}/`}>
                      {startCase(topic.fieldValue)}
                    </TopicItem>
                </li>
                ))}
            </Topics>
          </TopicsSection>
          <AuthorSection>
            <SectionTitle>
              About The Author
              <AllBtn><Button type="mini-primary" textColor='var(--color-secondaryText)' to="/ammaar-aslam">Learn More <HiArrowRight /> </Button></AllBtn>
            </SectionTitle>
            <AuthorInfo>
              <Bio />
            </AuthorInfo>
          </AuthorSection>
        </HomeBodyWrapper>
      </Layout>
    )
  }
}

export default BlogList

export const pageQuery = graphql`
  query blogListQuery($skip: Int!) {
    site {
      siteMetadata {
        title
        description
      }
    }
    topics: allMarkdownRemark(limit: 2000) {
      group(field: frontmatter___topics) {
        fieldValue
        totalCount
      }
    }
    posts: allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fileAbsolutePath: { regex: "//content/posts//" }
        frontmatter: { published: { ne: false }, unlisted: { ne: true } }
      }
      limit: 4
      skip: $skip
    ) {
      edges {
        node {
          excerpt
          timeToRead
          frontmatter {
            title
            topics
            language
            date
            slug
            cover {
              publicURL
            }
          }
        }
      }
    }
  }
`
